import styles from "./FeaturesChecklist.module.scss";
import { resolveIcon } from "./iconMap";

/**
 * Product template — product features band (Figma `4670-6912` / mobile
 * `5596-19406`): heading, then borderless icon+label rows on a 2-up grid.
 *
 * Deliberately NOT `PartnerBand`, though the two share their icon treatment
 * value-for-value (48px `rgba(239,65,54,.02)` circle, 8px `.04` ring, 28px glyph,
 * 20px gap — reproduced here from Figma, not imported). The bands differ in
 * structure: `PartnerBand` carries a heading + intro paragraphs and indents every
 * column after the first by 40px, while this band is heading-only. Extending
 * `PartnerBand` would edit a component live on five supplier types; a separate
 * stylesheet sharing zero selectors means the 18 live pages cannot regress by
 * construction, which is the same call Session 5 made for `CapabilityCards`.
 */
export default function FeaturesChecklist({
  eyebrow,
  heading,
  items = [],
  columns = 2,
  // Figma 4670-6927's glyph is the SAME mark as `lp-industry.svg`, verified
  // path-for-path: the export just carries the 56px wrapper (circle + ring) that
  // `.iconWrap` already draws in CSS, so its coordinates are the registry
  // asset's shifted by +14. Same #EF4136 fill. No new icon file was needed —
  // Session 2's "Figma icon exports include their wrapper" lesson again.
  markerIcon = "industry",
  surface = "grey",
}) {
  if (!items.length) return null;

  return (
    <section className={`${styles.section} ${styles[surface]}`}>
      <div className={styles.content}>
        {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
        {heading && <h2 className={styles.heading}>{heading}</h2>}

        <ul className={styles.list} style={{ "--cols": columns }}>
          {items.map((item, i) => (
            <li className={styles.item} key={i}>
              <span className={styles.iconWrap}>
                <img
                  src={resolveIcon(item.icon || markerIcon)}
                  alt=""
                  aria-hidden="true"
                />
              </span>
              <span className={styles.label}>{item.title}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
